/*
 * Favoritos (wishlist) — Ariel Malhas
 * Marcação leve de produtos favoritos via localStorage, sem backend.
 * Usa delegação de eventos para funcionar com cards carregados
 * dinamicamente (carrossel, filtros de coleção, recomendações).
 */
(function () {
  'use strict';

  var KEY = 'ariel_wishlist';

  function get() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]').map(String);
    } catch (e) {
      return [];
    }
  }

  function save(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {
      /* armazenamento indisponível — ignora */
    }
  }

  function reflect(btn, ids) {
    var id = btn.getAttribute('data-product-id');
    btn.setAttribute('aria-pressed', ids.indexOf(id) > -1 ? 'true' : 'false');
  }

  // Atualiza o estado visual de todos os corações presentes no escopo.
  function reflectAll(ctx) {
    var ids = get();
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    var buttons = scope.querySelectorAll('[data-ariel-wishlist]');
    Array.prototype.forEach.call(buttons, function (btn) {
      reflect(btn, ids);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-ariel-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-product-id');
    var arr = get();
    var i = arr.indexOf(id);
    if (i > -1) {
      arr.splice(i, 1);
    } else {
      arr.push(id);
    }
    save(arr);
    // Sincroniza todos os cards do mesmo produto.
    var twins = document.querySelectorAll(
      '[data-ariel-wishlist][data-product-id="' + id + '"]'
    );
    Array.prototype.forEach.call(twins, function (b) {
      reflect(b, arr);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reflectAll();
    });
  } else {
    reflectAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    reflectAll(e.target);
  });
})();
